"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Notification_1 = __importDefault(require("../../../elementKit/notification/Notification"));
const react_bootstrap_1 = require("react-bootstrap");
const close_icon_gray_svg_1 = __importDefault(require("../../../assets/images/icons/close-icon-gray.svg"));
const info_icon_svg_1 = __importDefault(require("../../../assets/images/icons/info-icon.svg"));
require("./signupOtpPopup.scss");
const signupOtpPopupTranslations_json_1 = __importDefault(require("./signupOtpPopupTranslations/signupOtpPopupTranslations.json"));
const BaseButton_1 = __importDefault(require("../../../elementKit/baseButton/BaseButton"));
const Recaptcha_1 = __importDefault(require("../../../elementKit/recaptcha/Recaptcha"));
const User_1 = require("../../../services/backend/User");
const storageUtils_1 = require("../../../services/utils/storageUtils");
const master_1 = require("../../../constants/master");
const SignupOtpPopup = (props) => {
    props.addTranslation(signupOtpPopupTranslations_json_1.default);
    const recaptchaRef = (0, react_1.useRef)(null);
    const [loginLoading, setLoginLoading] = (0, react_1.useState)(false);
    function extractFirstAndLastNameFromStr(fullName) {
        fullName = fullName.trim();
        // get the last word of the string and make it last name then rest is first name
        const nameArr = fullName.split(" ");
        const lastName = nameArr[nameArr.length - 1];
        const firstName = nameArr.slice(0, nameArr.length - 1).join(" ");
        return [firstName, lastName];
    }
    const triggerSignUpLoginOtp = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const token = yield ((_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.executeAsync());
        if (!token) {
            (0, Notification_1.default)({
                type: "error",
                text: props.translate("recaptchaError").toString(),
            });
            return;
        }
        setLoginLoading(true);
        if (props.userMeta.logged) {
            // LOG OUT
            props.dispatch(props.userSliceActions.logout());
            (0, Notification_1.default)({
                type: "success",
                text: props.translate("loggedOut"),
            });
        }
        const [firstName, lastName] = extractFirstAndLastNameFromStr(props.userFullName || "No Name");
        const otpBody = {
            email: props.userEmail,
            reCaptchaToken: token || "",
            firstName: firstName,
            lastName: lastName,
        };
        (0, storageUtils_1.clearStorageForLogout)();
        const data = yield (0, User_1.signupLoginOtp)(otpBody, "signup", (0, master_1.getMasterConfig)().subDomain);
        if (data != null && data.success) {
            props.dispatch(props.userSliceActions.setUserId(data.userId));
            const actionType = props.actionType;
            props.historyPush({
                pathname: `/${(_c = (_b = props.activeLanguage) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : "en"}/verify-code/`,
                search: `?email=${props.userEmail}`,
                state: {
                    status: data.status,
                    // Redirect After success key
                    shouldRedirectOptions: {
                        shouldRedirectTo: props.shouldRedirectTo,
                        redirectSearch: props.redirectSearch,
                        actionType: actionType,
                    },
                    // Redirect to back on header back button press
                    fromProfile: true,
                },
            });
        }
        else {
            (_d = recaptchaRef.current) === null || _d === void 0 ? void 0 : _d.reset();
            if (data) {
                (0, Notification_1.default)({
                    type: "error",
                    text: props.translate(data.error).toString(),
                });
            }
            else {
                (0, Notification_1.default)({
                    type: "error",
                    text: props.translate("error").toString(),
                });
            }
            setLoginLoading(false);
        }
        setLoginLoading(false);
    });
    return (react_1.default.createElement(react_bootstrap_1.Modal, { id: "signup-dialog", className: "verify-you", show: props.dialogOpen, onHide: props.handleClose, centered: true },
        react_1.default.createElement("img", { src: close_icon_gray_svg_1.default, alt: "Close", className: "close-icon", onClick: props.handleClose }),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, { className: "verify-you-body flex-row ai-fs" },
            react_1.default.createElement("img", { src: info_icon_svg_1.default, alt: "Info Icon", className: "modal-icon" }),
            react_1.default.createElement("div", { className: "verify-you-texts" },
                react_1.default.createElement("span", { className: "title-text" }, props.translate("weNeedToVerifyItsYou").toString()),
                react_1.default.createElement("span", { className: "desc-text", style: { marginTop: "15px", marginBottom: "15px" } }, props.translate(props.popupDescriptionTranslationKey).toString()))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, { className: "common-footer flex-row" },
            react_1.default.createElement(Recaptcha_1.default, { ref: recaptchaRef }),
            react_1.default.createElement(BaseButton_1.default, { type: "primary", size: "small", loading: loginLoading, height: 39, onClickAction: () => {
                    triggerSignUpLoginOtp();
                } },
                react_1.default.createElement("span", null,
                    " ",
                    props.translate("verifyEmailAddress").toString())))));
};
exports.default = SignupOtpPopup;
